import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom-v5-compat';
import { UserHasRoleAndSubscription } from '../../../role-based-route';
import { PagingContextProvider } from '../../../contexts/paging-context';
import { useUserSetting } from '../../../hooks/use-user-setting';
import { UserSettings } from '../../../enums/user-settings/user-settings';
import { PAGE_SIZE_50 } from '../../../services/pagination-service';
import { SuppliersGridContextProvider } from './suppliers-grid-context';

/**
 * Layout component for suppliers routes with Context Providers
 * Provides PagingContextProvider and SuppliersGridContextProvider to all nested routes (list and detail pages)
 */
export const SuppliersLayout = () => {
  const userSetting = useUserSetting(UserSettings.suppliersGridPageSize.settingName);
  const userPageSize = useMemo(() => parseInt(userSetting || PAGE_SIZE_50, 10), [userSetting]);

  return (
    <UserHasRoleAndSubscription>
      <PagingContextProvider page={1} pageSize={userPageSize}>
        <SuppliersGridContextProvider>
          <Outlet />
        </SuppliersGridContextProvider>
      </PagingContextProvider>
    </UserHasRoleAndSubscription>
  );
};
